import styled, { css } from 'styled-components'
import { device } from '../../../styles/GlobalVariables'
import Link from '../../../components/Link/Link'

interface StyledProgramItemProps {
  programImage: string
}

interface StyledDropdownProps {
  isOpen: boolean
}

interface StyledDropdownItemProps {
  isSelected: boolean
}

interface StyledNavProps {
  isSelected?: boolean
}

export const ProgramBackground = styled.div<StyledProgramItemProps>`
  /*background: linear-gradient(
    90deg,
    #06060d -34.07%,
    #0c0f1f 47.01%,
    #06060d 137.67%
  );*/
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90vh;
  background-size: cover;
  filter: blur(2px);
  z-index: -1;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`
export const GradientBG = styled.div`
  ${device.medium} {
    height: 140vh;
    position: absolute;
    top: 0;
    left: 0;
    width: unset;
  }

  width: 100%;
  background: linear-gradient(
    90deg,
    #06060d -34.07%,
    #161a2d 47.01%,
    #06060d 137.67%
  );
`

export const DynamicColumnsWrapper = styled.div`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  max-width: 2000px;
  margin: 0 0 4vw;

  @media only screen and (min-width: 2000px) {
    margin: 0 auto;
  }
`

export const BannerWrapper = styled.div`
  display: flex;
  width: auto;
  height: auto;
  justify-content: center;
  align-items: center;
  background: #1e1e1e;

  ${device.medium} {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
    background: transparent;
  }
`

export const TaboolaColumn = styled.div`
  display: none;

  ${device.small} {
    justify-content: center;
    display: flex;
    width: 529px;
    max-width: 100%;
    align-content: flex-start;
  }

  > div {
    max-width: 300px;
    width: 100%;
  }
`

export const ProgramPageWrapper = styled.div`
  max-width: 1394px;
  width: 100%;

  ${device.medium} {
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: baseline;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      width: 4px;
      height: 99.5%;
      background-image: url('https://media3.reshet.tv/image/upload/v1741598783/uploads/2025/904496725.webp');
      background-repeat: repeat-y;
    }
  }

  position: relative;
`
export const VideoBreadCrumb = styled.div<{ isMobile: boolean }>`
  display: ${props => (props.isMobile ? 'none' : 'flex')};
  padding-right: 5.73vw;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
`
export const Vod = styled.div`
  color: #969696;
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
export const VodTitle = styled.div`
  color: #fff;
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const ProgramMainMenu = styled.div`
  position: inherit;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  padding-bottom: 2.5rem;
  transition: background-color 0.5s ease;

  ${device.medium} {
    min-height: 630px;
  }
`
export const StyledDropdown = styled.div<StyledDropdownProps>`
  position: relative;
  color: #fff;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 1.44rem;
  font-style: normal;
  cursor: pointer;
  margin-right: 6vw;

  @media only screen and (max-width: 768px) {
    margin-right: 25px;
    font-size: 1.4rem;
  }
`
export const TabsNavWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 30px;
  padding-right: 5.73vw;
  padding-left: 5.73vw;
`

const TabsLink = (isSelected?: boolean) => {
  return css`
    position: relative;
    color: #fff;
    text-align: right;
    font-family: 'Narkiss Block RESHET', sans-serif;
    font-size: 1.44rem;
    font-style: normal;
    cursor: pointer;
    ${isSelected
      ? css`
          height: 40px;
          border-bottom: 4px solid #54fbfe;
          border-radius: 2px;
          cursor: default;
        `
      : ''};
    @media only screen and(max-width: 768px) {
      font-size: 1.4rem;
    }
  `
}

export const TabsNavItem = styled.h2`
  margin-block-start: 0;
  margin-block-end: 0;
  font-weight: normal;
  ${props => TabsLink(props.theme.isSelected === 'primary')}
`
export const TabsLinkIte = styled(Link)`
  text-decoration: none;
  ${TabsLink(false)}
`

export const Button = styled.a<StyledNavProps>`
  position: relative;
  color: #fff;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 1.44rem;
  font-style: normal;
  cursor: pointer;
  text-decoration: none;
  ${props =>
    props.isSelected
      ? css`
          width: auto;
          height: 40px;
          border-bottom: 4px solid #54fbfe;
          border-radius: 2px;
        `
      : ''};
  @media only screen and(max-width: 768px) {
    font-size: 1.4rem;
  }
`

export const ParentWrapper = styled.div`
  width: 100%;
  overflow-x: visible;
  height: 45px;
`

export const ProgramNavVideos = styled.div`
  ${device.medium} {
    display: flex;
    gap: 1.875rem;
    width: 100%;
    overflow: unset;
    position: relative;
  }

  display: flex;
  gap: 1.875rem;
  width: 100vw;
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
  text-wrap: nowrap;
  padding-left: 20px;
  margin-left: 20px;
  scrollbar-width: none;
`

export const DropdownButton = styled.h2<StyledNavProps>`
  font-size: 1.44rem;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-weight: normal;
  display: inline-block;
  font-family: 'Narkiss Block RESHET', sans-serif;
  cursor: pointer;
  margin-left: 12px;
  position: relative;
  ${props =>
    props.isSelected
      ? css`
          width: auto;
          height: 40px;
          border-bottom: 4px solid #54fbfe;
          border-radius: 2px;
        `
      : ''};

  @media only screen and (max-width: 768px) {
    &:after {
      width: 150%;
      right: 0;
    }
  }
`

export const ArrowSymbol = styled.div<StyledNavProps>`
  display: inline-block;

  img {
    width: 11px;
    height: 9px;
  }

  transform-origin: center;
  ${props =>
    props.theme.isOpen
      ? css`
          transform: rotate(180deg);
        `
      : ''}
`

export const DropdownSeasonsList = styled.h2<StyledDropdownProps>`
  position: absolute;
  direction: rtl;
  margin-top: 0.9vw;
  width: auto;
  border-radius: 8px;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  background-color: #1e1f27;
  font-weight: normal;
  z-index: 2;
  right: 6vw;
  @media only screen and (max-width: 768px) {
    margin-top: 3.4vw;
  }

  a {
    text-decoration: none;
  }
`

export const DropdownItem = styled.div<StyledDropdownItemProps>`
  padding: 14.5px;
  cursor: pointer;
  font-size: 1.188rem;
  color: ${props => (props.isSelected ? '#54FBFE' : '#fff')};

  &:hover {
    color: #54fbfe;
  }
`
